import BusinessTripFormEntityContent from '@/components/entity-detail/components/Entity/BusinessTripFormEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { BUSINESS_TRIP_FORM_PARAMS } from '@/constants/query-params/business-trip-form.constant';
import { businessTripFormService } from '@/services/rest';
import type { BusinessTripFormResponse } from '@/types/apps/business-trip-form.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class BusinessTripFormEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Phiếu công tác');
        }

        console.log(response);

        return `Phiếu công tác: ${response?.code} - ${response?.customer?.name}`;
    }

    public getEntityComponent(): any {
        return BusinessTripFormEntityContent;
    }

    public getIncludeProperties() {
        return BUSINESS_TRIP_FORM_PARAMS;
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<BusinessTripFormResponse>> {
        return businessTripFormService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.BUSINESS_TRIP_FORM_DETAIL;
    }
}
